// FASE B-6 (super-plano) — os 6 handlers de replyAction (a classificação de um
// turno SEM tool calls) saíram do spine runLocalAgentLoopInner pra cá. O spine
// só chama isto e OBEDECE o directive devolvido (continue|return). Os eventos
// emitidos e sua ORDEM são idênticos ao bloco inline (golden traces intactos):
// as impurezas (onEvent, applySpineEvent) chegam por parâmetro — este módulo é
// framework-free (loop/). Retorno:
//   { control: 'continue' }                      → o spine faz `continue`
//   { control: 'return', value: <resultado> }    → o spine faz `return value`
//   { control: 'fallthrough' }                   → nenhum handler casou; segue o
//                                                   fluxo tardio (audit/oracle/done)
export function applyToollessReply(replyAction, ctx) {
  const { s, content, onEvent, applySpineEvent, maxIterations, nudges } = ctx;
  const k = replyAction.kind;

  if (k === 'plan_nudge') {
    applySpineEvent(s, { type: 'nudge', which: 'plan' });
    applySpineEvent(s, { type: 'convo_push', message: { role: 'user', content: nudges.presentPlan } });
    return { control: 'continue' };
  }
  if (k === 'action_claim_nudge') {
    applySpineEvent(s, { type: 'nudge', which: 'actionClaim' });
    applySpineEvent(s, { type: 'convo_push', message: { role: 'user', content: nudges.toolBeforeClaim } });
    return { control: 'continue' };
  }
  if (k === 'action_claim_block') {
    // harness-audit 07-13 — claim de escrita que persiste após o nudge (espelho do green-claim block).
    onEvent({ type: 'loop_stop', stopReason: 'unbacked_write_claim', iterations: s.iteration + 1 });
    return { control: 'return', value: { ok: false, finalText: s.finalText, iterations: s.iteration + 1, stopReason: 'unbacked_write_claim', maxIterations } };
  }
  if (k === 'plan_done') {
    onEvent({ type: 'done', content });
    return { control: 'return', value: { ok: true, finalText: s.finalText, iterations: s.iteration + 1, stopReason: 'plan_prose', maxIterations } };
  }
  if (k === 'conversational_done') {
    onEvent({ type: 'done', content });
    return { control: 'return', value: { ok: true, finalText: s.finalText, iterations: s.iteration + 1, stopReason: 'conversational_reply', maxIterations } };
  }
  if (k === 'nudge_stop') {
    onEvent({ type: 'loop_stop', stopReason: replyAction.stopReason, iterations: s.iteration + 1 });
    return { control: 'return', value: { ok: false, finalText: s.finalText, iterations: s.iteration + 1, stopReason: replyAction.stopReason, maxIterations } };
  }
  if (k === 'nudge') {
    const n = replyAction.nudge;
    if (n.bumpStall) applySpineEvent(s, { type: 'nudge', which: 'stall' });
    if (n.setToolFailureNudged) applySpineEvent(s, { type: 'nudge', which: 'toolFailure' });
    if (n.setCommitNudged) applySpineEvent(s, { type: 'nudge', which: 'commit' });
    applySpineEvent(s, { type: 'convo_push', message: { role: 'user', content: n.message } });
    return { control: 'continue' };
  }
  return { control: 'fallthrough' };
}
